import { render, staticRenderFns } from "./OfficialLanding.vue?vue&type=template&id=1c2cb6fb&scoped=true"
import script from "./OfficialLanding.vue?vue&type=script&lang=js"
export * from "./OfficialLanding.vue?vue&type=script&lang=js"
import style0 from "./OfficialLanding.vue?vue&type=style&index=0&id=1c2cb6fb&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2cb6fb",
  null
  
)

export default component.exports